/**
 * Early Bird：未配产品图时，SKU 切换同步变体主图（配合 festival-productcard-bs data-use-variant-image）
 */
(function () {
  function syncVariantProductImage(selectEl) {
    if (!selectEl || !selectEl.value) return;
    var card = selectEl.closest('.cla-pcard-item');
    if (!card || !card.getAttribute('data-use-variant-image')) return;
    var priceItem = card.querySelector('.pcard-price-item[data-sku-id="' + selectEl.value + '"]');
    if (!priceItem) return;
    var src = priceItem.getAttribute('data-variant-image-src');
    if (!src) return;
    card.querySelectorAll('.js-pcard-variant-img').forEach(function (img) {
      img.src = src;
    });
    card.querySelectorAll('.js-pcard-variant-img-m').forEach(function (img) {
      img.src = src;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var original = window.skuSelectChange;
    window.skuSelectChange = function (target) {
      if (typeof original === 'function') {
        original(target);
      }
      syncVariantProductImage(target);
    };

    document.querySelectorAll('.bs-sku-select').forEach(function (selectEl) {
      syncVariantProductImage(selectEl);
    });
  });
})();
